import Nanobus from "nanobus";
var CreateButton = /** @class */ (function () {
    function CreateButton() {
        this.element = this.createElement();
        this.state = true;
        this.events = new Nanobus();
        this.placeElement();
        this.initEvents();
    }
    CreateButton.prototype.placeElement = function () {
        var _this = this;
        var previousElement = document.querySelector('.page-title-action');
        if (previousElement) {
            setTimeout(function () {
                previousElement.insertAdjacentElement('afterend', _this.element);
            }, 200);
        }
    };
    CreateButton.prototype.initEvents = function () {
        var _this = this;
        this.element.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.state) {
                _this.events.emit('click');
            }
        });
    };
    CreateButton.prototype.getElement = function () {
        return this.element;
    };
    CreateButton.prototype.hide = function () {
        this.getElement().style.display = 'none';
    };
    CreateButton.prototype.show = function () {
        this.getElement().style.display = 'inline-block';
    };
    CreateButton.prototype.enable = function () {
        this.show();
        this.state = true;
    };
    CreateButton.prototype.disable = function () {
        this.hide();
        this.state = false;
    };
    CreateButton.prototype.createElement = function () {
        var element = document.createElement('a');
        element.classList.add('ac-button');
        element.classList.add('ac-add-new-inline');
        element.classList.add('add-new-h2');
        element.id = 'ac-button-add-new-inline';
        element.innerText = ACP_ADD_NEW_INLINE.i18n.add_new;
        return element;
    };
    return CreateButton;
}());
export default CreateButton;
